/* eslint-disable no-eval */
<template>
  <div class="main-view">
    <el-tabs v-model="tabName" tab-position="left" class="agentRegister" >
      <el-tab-pane label="代理商意向调查" name="survey">
      </el-tab-pane>
      <el-tab-pane label="代理商入网申请" name="agentInfo">
      </el-tab-pane>
    </el-tabs>

    <div v-show="tabName === 'survey'" class="rightContent">
      <h3 class="margBt">基本信息</h3>
      <el-form :model="surveyInfo" ref="surveyInfo" :rules="rule_data" label-position="left">
        <el-form-item prop="FBusinessBDName" label="业务BD">
          <el-input class="form-input" v-model.trim="surveyInfo.FBusinessBDName" placeholder="业务BD姓名" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item prop="FBusinessLicenseName" label="公司名称">
          <el-input class="form-input" v-model="surveyInfo.FBusinessLicenseName" placeholder="营业执照上全称"></el-input>
        </el-form-item>
        <el-form-item prop="FBusinessName" label="公司简称">
          <el-input class="form-input" v-model="surveyInfo.FBusinessName" placeholder="请输入公司简称"></el-input>
        </el-form-item>
        <el-form-item prop="FBusinessUrl" label="公司网址">
          <el-input class="form-input" v-model="surveyInfo.FBusinessUrl" placeholder="已具备公司网址"></el-input>
        </el-form-item>
        <el-form-item prop="FContactName" label="联系人姓名">
          <el-input class="form-input" v-model="surveyInfo.FContactName" placeholder="请输入联系人姓名"></el-input>
        </el-form-item>
        <el-form-item prop="FContactMobile" label="联系人手机">
          <el-input class="form-input" v-model="surveyInfo.FContactMobile" placeholder="请输入联系人手机"></el-input>
        </el-form-item>
        <el-form-item label="办公经营地址" required>
          <el-row type="flex">
            <el-form-item prop="FWorkProvince" class="form-flex-item">
              <el-select
                v-model="surveyInfo.FWorkProvince"
                placeholder="请选择省"
                @change="setProv($event,'FWorkProvince')"
                clearable
                filterable
                style="width:120px;">
                <el-option
                  v-for="item in pro_list"
                  :key="item.F_province_no"
                  :label="item.F_province_name"
                  :value="item.F_province_no" >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="FWorkCity" class="form-flex-item">
              <el-select
                v-model="surveyInfo.FWorkCity"
                placeholder="请选择市"
                @change="setCity($event,'FWorkCity')"
                clearable
                filterable
                style="width: 120px;">
                <el-option
                  v-for="item in city_list.FWork"
                  :key="item.F_city_no"
                  :label="item.F_city_name"
                  :value="item.F_city_no">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="FWorkArea" class="form-flex-item">
              <el-select
                v-model="surveyInfo.FWorkArea"
                placeholder="请选择区"
                @change="setArea($event,'FWorkArea')"
                clearable
                filterable
                style="width: 120px;">
                <el-option
                  v-for="item in area_list.FWork"
                  :key="item.F_area_no"
                  :label="item.F_area_name"
                  :value="item.F_area_no">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="FWorkAddress" class="form-input">
              <el-input v-model="surveyInfo.FWorkAddress" placeholder="请输入详细地址"></el-input>
            </el-form-item>
          </el-row>
        </el-form-item>
        <el-form-item label="营业执照注册地址" required>
          <el-row type="flex">
            <el-form-item prop="FLicenseProvince" class="form-flex-item">
              <el-select
                v-model="surveyInfo.FLicenseProvince"
                placeholder="请选择省"
                @change="setProv($event,'FLicenseProvince')"
                clearable
                filterable
                style="width:120px;">
                <el-option
                  v-for="item in pro_list"
                  :key="item.F_province_no"
                  :label="item.F_province_name"
                  :value="item.F_province_no" >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="FLicenseCity" class="form-flex-item">
              <el-select
                v-model="surveyInfo.FLicenseCity"
                placeholder="请选择市"
                @change="setCity($event,'FLicenseCity')"
                clearable
                filterable
                style="width: 120px;">
                <el-option
                  v-for="item in city_list.FLicense"
                  :key="item.F_city_no"
                  :label="item.F_city_name"
                  :value="item.F_city_no">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="FLicenseArea" class="form-flex-item">
              <el-select
                v-model="surveyInfo.FLicenseArea"
                placeholder="请选择区"
                @change="setArea($event,'FLicenseArea')"
                clearable
                filterable
                style="width: 120px;">
                <el-option
                  v-for="item in area_list.FLicense"
                  :key="item.F_area_no"
                  :label="item.F_area_name"
                  :value="item.F_area_no">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="FLicenseAddress" class="form-input">
              <el-input v-model="surveyInfo.FLicenseAddress" placeholder="请输入详细地址"></el-input>
            </el-form-item>
          </el-row>
        </el-form-item>
        <h3>业务了解</h3>
        <el-form-item label="接入存量商户主营行业、服务类型？" prop="FBusinessMainIndustry">
          <el-input v-model="surveyInfo.FBusinessMainIndustry" type="textarea" autosize placeholder="请输入接入存量商户主营行业、服务类型" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="存量商户日均交易笔数" prop="FBusinessDailyAverageTransNum">
          <el-input v-model="surveyInfo.FBusinessDailyAverageTransNum" type="textarea" autosize placeholder="请输入存量商户日均交易笔数" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="存量商户日均交易金额" prop="FBusinessDailyAverageTransAmount">
          <el-input v-model="surveyInfo.FBusinessDailyAverageTransAmount" type="textarea" autosize placeholder="请输入存量商户日均交易金额" :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="是否具有api技术对接能力" prop="FBusinessDockingApiAbility">
          <el-input v-model="surveyInfo.FBusinessDockingApiAbility" type="textarea" autosize placeholder="请输入是否具有api技术对接能力" :maxlength="20"></el-input>
        </el-form-item>
        <h3 class="margBt">图片信息（图片小于3M）</h3>
        <el-row>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics.FLeasingContractPicUrl"
              theme="material"
              @onChange="upload('FLeasingContractPic')"
              size="normal"
              v-loading="picLoadingArr.FLeasingContractPic"
              accept="image/*"
              :imgSrc="pics.FLeasingContractPic"
              placeholder="租赁合同"
              :max-size="picMaxSize"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><font color="red">*</font><label>租赁合同</label></el-row>
          </el-col>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics.FPlaceOfBusinessPicUrl"
              theme="material"
              @onChange="upload('FPlaceOfBusinessPic')"
              size="normal"
              v-loading="picLoadingArr.FPlaceOfBusinessPic"
              accept="image/*"
              :imgSrc="pics.FPlaceOfBusinessPic"
              placeholder="办公经营场所照"
              :max-size="picMaxSize"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><font color="red">*</font><label>办公经营场所照</label></el-row>
          </el-col>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics.FLegalPersonFrontPicUrl"
              theme="material"
              @onChange="upload('FLegalPersonFrontPic')"
              size="normal"
              v-loading="picLoadingArr.FLegalPersonFrontPic"
              accept="image/*"
              :imgSrc="pics.FLegalPersonFrontPic"
              placeholder="法人身份证正面照"
              :max-size="picMaxSize"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><font color="red">*</font><label>法人身份证正面照</label></el-row>
          </el-col>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics.FLegalPersonBackPicUrl"
              theme="material"
              @onChange="upload('FLegalPersonBackPic')"
              size="normal"
              v-loading="picLoadingArr.FLegalPersonBackPic"
              accept="image/*"
              :imgSrc="pics.FLegalPersonBackPic"
              placeholder="法人身份证反面照"
              :max-size="picMaxSize"
              class="imgPad img3">
            </VueImgInputer>
            <el-row class="pic_label_text"><font color="red">*</font><label>法人身份证反面照</label></el-row>
          </el-col>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics.FBusinessLicensePicUrl"
              theme="material"
              @onChange="upload('FBusinessLicensePic')"
              size="normal"
              v-loading="picLoadingArr.FBusinessLicensePic"
              accept="image/*"
              :imgSrc="pics.FBusinessLicensePic"
              placeholder="营业执照照"
              :max-size="picMaxSize"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><font color="red">*</font><label>营业执照照</label></el-row>
          </el-col>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics.FOpeningPermitPicUrl"
              theme="material"
              @onChange="upload('FOpeningPermitPic')"
              size="normal"
              v-loading="picLoadingArr.FOpeningPermitPic"
              accept="image/*"
              :imgSrc="pics.FOpeningPermitPic"
              placeholder="开户许可证"
              :max-size="picMaxSize"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><font color="red">*</font><label>开户许可证</label></el-row>
          </el-col>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics.FBusinessTransactionPicUrl"
              theme="material"
              @onChange="upload('FBusinessTransactionPic')"
              size="normal"
              v-loading="picLoadingArr.FBusinessTransactionPic"
              accept="image/*"
              :imgSrc="pics.FBusinessTransactionPic"
              placeholder="商户交易数据截图"
              :max-size="picMaxSize"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><label>商户交易数据截图</label></el-row>
          </el-col>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics.FWxRiskMerchantManagementPicUrl"
              theme="material"
              @onChange="upload('FWxRiskMerchantManagementPic')"
              size="normal"
              v-loading="picLoadingArr.FWxRiskMerchantManagementPic"
              accept="image/*"
              :imgSrc="pics.FWxRiskMerchantManagementPic"
              placeholder="微信服务商后台【风险商户管理】截图"
              :max-size="picMaxSize"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><label>微信服务商后台【风险商户管理】</label></el-row>
          </el-col>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics.FWxCustomerComplaintPicUrl"
              theme="material"
              @onChange="upload('FWxCustomerComplaintPic')"
              size="normal"
              v-loading="picLoadingArr.FWxCustomerComplaintPic"
              accept="image/*"
              :imgSrc="pics.FWxCustomerComplaintPic"
              placeholder="微信服务商后台【消费者投诉界面】截图"
              :max-size="picMaxSize"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><label>微信服务商后台【消费者投诉界面】</label></el-row>
          </el-col>
        </el-row>
        <h5>说明：微信服务商后台截图对应数据默认展示筛选近一月，若无数据，将时间扩展至3月。</h5>
        <el-form-item class="btnItem">
          <el-button type="primary" @click="submitSurvey" :loading="submitSurveyLoading">提交</el-button>
          <el-button @click="close">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-show="tabName === 'agentInfo'" class="rightContent">
      <el-form label-position="left" ref="agentInfo" :model="agentInfo" :rules="rule_agent">
        <el-form-item label="代理商类型" prop="FSubAgentClass" placehoder="请选择代理商类型">
          <el-select v-model="agentInfo.FSubAgentClass">
            <el-option label="普通saas代理商" :value="0"></el-option>
            <el-option label="云闪付系代理商" :value="1"></el-option>
            <el-option label="威富通系代理商" :value="2"></el-option>
            <el-option label="富友系代理商" :value="3"></el-option>
            <el-option label="网商系代理商" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="授权码" prop="authCode">
          <el-input class="form-input" v-model="agentInfo.authCode" placeholder="联系工作人员提供" @blur="getInfoByCode"></el-input>
        </el-form-item>
        <h3 class="margBt">聚合后台登录信息</h3>
        <el-form-item ref="addFormUserNameItem" label="代理商账号" prop="FAgentAccount" :error="FAgentAccountError">
          <el-input class="form-input" v-model="agentInfo.FAgentAccount" placeholder="6-20位字母、数字、下划线" prop="FAgentAccount"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="FAgentPassword">
          <el-input class="form-input" v-model="agentInfo.FAgentPassword" placeholder="6-20位字母、数字、下划线" ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input class="form-input" v-model="agentInfo.confirmPassword" placeholder="同登录密码保持一致" ></el-input>
        </el-form-item>
        <el-form-item label="绑定手机" prop="FMobile">
          <el-input class="form-input" v-model="agentInfo.FMobile" placeholder="11位手机号"></el-input>
        </el-form-item>
        <h3 class="margBt">公司信息</h3>
        <el-form-item label="公司名称" required>
          <el-input class="form-input" v-model="agentInfo.FTitle" placeholder="公司名称" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="注册资金" prop="FRegisteredCapital">
          <el-input class="form-input" v-model="agentInfo.FRegisteredCapital" placeholder="输入整数"></el-input>
        </el-form-item>
        <el-form-item label="法人姓名" prop="FName">
          <el-input class="form-input" v-model="agentInfo.FName" placeholder="至少2位"></el-input>
        </el-form-item>
        <el-form-item label="法人身份证号" prop="FIdentityCard">
          <el-input class="form-input" v-model="agentInfo.FIdentityCard" placeholder="18位身份证号"></el-input>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="FEmail">
          <el-input class="form-input" v-model="agentInfo.FEmail" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="回调url" prop="FNotifyAddress">
          <el-input class="form-input" v-model="agentInfo.FNotifyAddress"></el-input>
        </el-form-item>
        <el-form-item label="公司所在地址" required>
          <el-row type="flex">
            <el-form-item class="form-flex-item">
              <el-select
                v-model="agentInfo.FAgentProvince"
                placeholder="请选择省"
                clearable
                filterable
                style="width:120px;"
                :disabled="true">
                <el-option
                  v-for="item in pro_list"
                  :key="item.F_province_no"
                  :label="item.F_province_name"
                  :value="item.F_province_name" >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="form-flex-item">
              <el-select
                v-model="agentInfo.FAgentCity"
                placeholder="请选择市"
                clearable
                filterable
                style="width: 120px;"
                :disabled="true">
                <el-option
                  v-for="item in city_list.company"
                  :key="item.F_city_no"
                  :label="item.F_city_name"
                  :value="item.F_city_name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="form-flex-item">
              <el-select
                v-model="agentInfo.FAgentArea"
                placeholder="请选择区"
                clearable
                filterable
                style="width: 120px;"
                :disabled="true">
                <el-option
                  v-for="item in area_list.company"
                  :key="item.F_area_no"
                  :label="item.F_area_name"
                  :value="item.F_area_name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="form-input">
              <el-input v-model="agentInfo.FAddress" placeholder="详细地址需超过5个字，详细到门牌号" :disabled="true"></el-input>
            </el-form-item>
          </el-row>
        </el-form-item>
        <h3 class="margBt">结算信息（只支持对公结算）</h3>
        <el-form-item label="开户名" prop="FBankAccount">
          <el-input class="form-input" v-model="agentInfo.FBankAccount" placeholder="开户许可证上公司名称"></el-input>
        </el-form-item>
        <el-form-item
          label="开户行"
          :rules="{
            required: true,
            message: '请选择开户行',
            trigger: 'change'
          }"
          prop="FBankType">
          <el-select
            style="width:200px;"
            filterable
            v-model="agentInfo.FBankType"
            @change="setBankName"
            placeholder="请选择"
            clearable
            class="FBankType">
            <el-option
              v-for="item in bank_list"
              :key="item.F_bank_name_code"
              :label="item.F_bank_name"
              :value="item.F_bank_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="银行网点" required>
          <el-row type="flex">
            <el-form-item
              class="form-flex-item"
              prop="FBankArea"
              :rules="{
                required: true,
                message: '请选择省',
                trigger: 'change'
              }">
              <el-select
                v-model="agentInfo.FBankArea"
                placeholder="请选择省"
                @change="setBankPro"
                clearable
                filterable
                style="width:120px;"
                class="FBankArea" >
                <el-option
                  v-for="item in bank_pro_list"
                  :key="item.F_bank_area_code"
                  :label="item.F_bank_area"
                  :value="item.F_bank_area"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              class="form-flex-item"
              prop="FBankCity"
              :rules="{
                required: true,
                message: '请选择市',
                trigger: 'change'
              }">
              <el-select
                ref="addFormFBankCityItem"
                v-model="agentInfo.FBankCity"
                placeholder="请选择市"
                @change="setBankCity"
                @focus="handleBankCityFocus"
                clearable
                filterable
                style="width: 120px;"
                class="FBankCity">
                <el-option
                  v-for="item in bank_city_list"
                  :key="item.F_bank_city_code"
                  :label="item.F_bank_city"
                  :value="item.F_bank_city"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="FBankPoint"
              :rules="{
                required: true,
                message: '分行网点',
                trigger: 'change'
              }">
              <el-select
                class="inline-input branch-input branch"
                ref="addFormbranchItem"
                v-model="agentInfo.FBankPoint"
                @change="setBankBranch"
                placeholder="分行网点（模糊查询）"
                @focus="handleBankBranchFocus"
                clearable
                filterable>
                <el-option
                  v-for="item in branch_list"
                  :key="item.F_branch_no"
                  :label="item.F_branch_name"
                  :value="item.F_branch_name"></el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </el-form-item>
        <el-form-item id="bankCardId" label="银行卡号" prop="FBankCardid">
          <el-input class="form-input bankCardId" v-model="agentInfo.FBankCardid" placeholder="开户许可证号" @blur="handleBankCardIdBlur"></el-input>
          <span class="luhm-bankCard-tip-view" v-show="isBankCardIdLuhmChecked">
            <i class="el-icon-warning"></i>
            <span>银行卡号可能存在错误风险，请仔细核对</span>
          </span>
        </el-form-item>
        <el-form-item label="确认银行卡号" prop="confirmBankCardId">
          <el-input class="form-input" v-model="agentInfo.confirmBankCardId" placeholder="确认开户许可证号"></el-input>
        </el-form-item>
        <h3 class="margBt">图片信息（图片小于3M）</h3>
        <el-row>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics2.FBdagentPhotoUrl"
              theme="material"
              @onChange="upload2('FBdagentPhoto')"
              size="normal"
              v-loading="picLoadingArr2.FBdagentPhoto"
              accept="image/*"
              :imgSrc="pics2.FBdagentPhoto"
              placeholder="办公经营场所照"
              :max-size="picMaxSize"
              :readonly="true"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><font color="red">*</font><label>办公经营场所照</label></el-row>
          </el-col>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics2.FIdentityCardFrontUrl"
              theme="material"
              @onChange="upload2('FIdentityCardFront')"
              size="normal"
              v-loading="picLoadingArr2.FIdentityCardFront"
              accept="image/*"
              :imgSrc="pics2.FIdentityCardFront"
              placeholder="法人身份证正面照"
              :max-size="picMaxSize"
              :readonly="true"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><font color="red">*</font><label>法人身份证正面照</label></el-row>
          </el-col>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics2.FIdentityCardBackUrl"
              theme="material"
              @onChange="upload2('FIdentityCardBack')"
              size="normal"
              v-loading="picLoadingArr2.FIdentityCardBack"
              accept="image/*"
              :imgSrc="pics2.FIdentityCardBack"
              placeholder="法人身份证反面照"
              :max-size="picMaxSize"
              :readonly="true"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><font color="red">*</font><label>法人身份证反面照</label></el-row>
          </el-col>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics2.FBusinessLicenseUrl"
              theme="material"
              @onChange="upload2('FBusinessLicense')"
              size="normal"
              v-loading="picLoadingArr2.FBusinessLicense"
              accept="image/*"
              :imgSrc="pics2.FBusinessLicense"
              placeholder="营业执照照"
              :max-size="picMaxSize"
              :readonly="true"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><font color="red">*</font><label>营业执照照</label></el-row>
          </el-col>
          <el-col :span="8" class="relat">
            <VueImgInputer
              v-model="pics2.FTaxRegistrationUrl"
              theme="material"
              @onChange="upload2('FTaxRegistration')"
              size="normal"
              v-loading="picLoadingArr2.FTaxRegistration"
              accept="image/*"
              :imgSrc="pics2.FTaxRegistration"
              placeholder="开户许可证"
              :max-size="picMaxSize"
              :readonly="true"
              class="imgPad img3"></VueImgInputer>
            <el-row class="pic_label_text"><font color="red">*</font><label>开户许可证</label></el-row>
          </el-col>
        </el-row>
        <el-form-item class="btnItem">
          <el-button type="primary" @click="submitAgent" :loading="submitAgentLoading">提交</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>
<script>
import qs from 'qs'
import VueImgInputer from 'vue-img-inputer'
import luhmCheck from '@/utils/luhmCheck.js'
import { uploadPic, singleTransPic, agentSurvey, getInfoByAuthCode } from '@/api/global'
import { checkUsername, agentRegister } from '@/api/merchant'
export default {
  name: 'AgentRegister',
  components: {
    VueImgInputer
  },
  data () {
    return {
      tabName: 'survey',
      rule_data: {
        FBusinessBDName: [{
          required: true,
          message: '请输入业务BD',
          trigger: 'blur'
        }],
        FBusinessLicenseName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入公司名称'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?!^\w+$)^.{5,20}$/.test(value)) {
                callback()
              } else {
                callback(new Error('公司名称为长度5~20的汉字或汉字与数字组合'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FBusinessName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入公司简称'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?!^\w+$)^.{5,20}$/.test(value)) {
                callback()
              } else {
                callback(new Error('公司名称为长度5~20的汉字或汉字与数字组合'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FContactName: [{
          required: true,
          trigger: 'blur',
          pattern: /^[\u4e00-\u9fa5]{2,6}$/,
          message: '请输入2-6位中文姓名'
        }],
        FContactMobile: [
          { required: true, message: '请输入联系人手机号', trigger: 'blur' },
          { len: 11, message: '请输入11位手机号码', trigger: 'blur' }
        ],
        FWorkProvince: [{
          required: true,
          message: '请选择省份',
          trigger: 'change'
        }],
        FWorkCity: [{
          required: true,
          message: '请选择市级',
          trigger: 'change'
        }],
        FWorkArea: [{
          required: true,
          message: '请选择区域',
          trigger: 'change'
        }],
        FWorkAddress: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入详细地址'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?!^\w+$)^.{5,40}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入5位以上详细地址'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FLicenseProvince: [{
          required: true,
          message: '请选择省份',
          trigger: 'change'
        }],
        FLicenseCity: [{
          required: true,
          message: '请选择市级',
          trigger: 'change'
        }],
        FLicenseArea: [{
          required: true,
          message: '请选择区域',
          trigger: 'change'
        }],
        FLicenseAddress: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入详细地址'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?!^\w+$)^.{5,40}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入5位以上详细地址'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FBusinessMainIndustry: [{
          required: true,
          message: '请输入接入存量商户主营行业、服务类型',
          trigger: 'blur'
        }],
        FBusinessDailyAverageTransNum: [{
          required: true,
          message: '请输入存量商户日均交易笔数',
          trigger: 'blur'
        }],
        FBusinessDailyAverageTransAmount: [{
          required: true,
          message: '请输入存量商户日均交易金额',
          trigger: 'blur'
        }],
        FBusinessDockingApiAbility: [{
          required: true,
          message: '请输入是否具有api技术对接能力',
          trigger: 'blur'
        }]
      },
      surveyInfo: {
        FBusinessBDName: '', // 业务BD姓名
        FBusinessLicenseName: '',
        FBusinessName: '',
        FBusinessUrl: '',
        FContactName: '',
        FContactMobile: '',
        FWorkProvince: '',
        FWorkCity: '',
        FWorkArea: '',
        FWorkProvinceNo: '',
        FWorkCityNo: '',
        FWorkAreaNo: '',
        FWorkAddress: '',
        FLicenseProvince: '',
        FLicenseCity: '',
        FLicenseArea: '',
        FLicenseProvinceNo: '',
        FLicenseCityNo: '',
        FLicenseAreaNo: '',
        FLicenseAddress: '',
        FBusinessMainIndustry: '',
        FBusinessDailyAverageTransNum: '',
        FBusinessDailyAverageTransAmount: '',
        FBusinessDockingApiAbility: '',
        FLeasingContractPicUrl: '',
        FPlaceOfBusinessPicUrl: '',
        FLegalPersonFrontPicUrl: '',
        FLegalPersonBackPicUrl: '',
        FBusinessLicensePicUrl: '',
        FOpeningPermitPicUrl: '',
        FBusinessTransactionPicUrl: '',
        FWxRiskMerchantManagementPicUrl: '',
        FWxCustomerComplaintPicUrl: ''
      },
      pro_list: [], // 省份列表
      city_list: {
        FWork: [],
        FLicense: [],
        company: []
      }, // 城市列表
      area_list: {
        FWork: [],
        FLicense: [],
        company: []
      }, // 区列表
      picMaxSize: 1024 * 3,
      pics: {
        FLeasingContractPic: '',
        FPlaceOfBusinessPic: '',
        FLegalPersonFrontPic: '',
        FLegalPersonBackPic: '',
        FBusinessLicensePic: '',
        FOpeningPermitPic: '',
        FBusinessTransactionPic: '',
        FWxRiskMerchantManagementPic: '',
        FWxCustomerComplaintPic: '',
        // 上面是绝对路径，存储到数据库，下面是url，显示到页面

        FLeasingContractPicUrl: '',
        FPlaceOfBusinessPicUrl: '',
        FLegalPersonFrontPicUrl: '',
        FLegalPersonBackPicUrl: '',
        FBusinessLicensePicUrl: '',
        FOpeningPermitPicUrl: '',
        FBusinessTransactionPicUrl: '',
        FWxRiskMerchantManagementPicUrl: '',
        FWxCustomerComplaintPicUrl: ''
      },
      picLoadingArr: [
        { FLeasingContractPic: false },
        { FPlaceOfBusinessPic: false },
        { FLegalPersonFrontPic: false },
        { FLegalPersonBackPic: false },
        { FBusinessLicensePic: false },
        { FOpeningPermitPic: false },
        { FBusinessTransactionPic: false },
        { FWxRiskMerchantManagementPic: false },
        { FWxCustomerComplaintPic: false }],
      picCheck: {
        FLeasingContractPic: {
          key: 'FLeasingContractPic',
          required: true,
          label: '租赁合同'
        },
        FPlaceOfBusinessPic: {
          key: 'FPlaceOfBusinessPic',
          required: true,
          label: '办公经营场所照'
        },
        FLegalPersonFrontPic: {
          key: 'FLegalPersonFrontPic',
          required: true,
          label: '法人身份证正面照'
        },
        FLegalPersonBackPic: {
          key: 'FLegalPersonBackPic',
          required: true,
          label: '法人身份证反面照'
        },
        FBusinessLicensePic: {
          key: 'FBusinessLicensePic',
          required: true,
          label: '营业执照照'
        },
        FOpeningPermitPic: {
          key: 'FOpeningPermitPic',
          required: true,
          label: '开户许可证'
        },
        FBusinessTransactionPic: {
          required: false
        },
        FWxRiskMerchantManagementPic: {
          required: false
        },
        FWxCustomerComplaintPic: {
          required: false
        }
      },
      submitSurveyLoading: false,
      domain: 'https://baseweb.lszzg.com/',
      agentInfo: {
        FSubAgentClass: '', // 代理商类型
        authCode: '',
        FAgentAccount: '',
        FAgentPassword: '',
        confirmPassword: '',
        FMobile: '',
        FTitle: '',
        FRegisteredCapital: '',
        FName: '',
        FIdentityCard: '',
        FEmail: '',
        FNotifyAddress: '',
        FAgentProvince: '',
        FAgentCity: '',
        FAgentArea: '',
        FAddress: '',
        FBankAccount: '',
        FBankType: '',
        FBankTypeCode: '', // 开户行编号
        FBankArea: '', // 银行网点省名称
        FBankAreaCode: '', // 银行网点省名称
        FBankCity: '',
        FBankCityCode: '',
        FBankPoint: '', // 分行网点名称
        FUnionpayCode: '', // 联行好
        FBankCardid: '',
        confirmBankCardId: '',
        FBdagentPhoto: '',
        FIdentityCardFront: '',
        FIdentityCardBack: '',
        FBusinessLicense: '',
        FTaxRegistration: ''
      }, // 代理商入网表单
      rule_agent: {
        FSubAgentClass: [
          {
            required: true,
            message: '请选择代理商类型',
            trigger: 'change'
          }
        ], // 代理商类型
        authCode: [
          {
            required: true,
            message: '请输入授权码',
            trigger: 'blur'
          }
        ],
        FAgentAccount: [{ required: true, message: '请输入代理商账号', trigger: 'blur' }, {
          validator: (rule, value, callback) => {
            if (/^[a-zA-Z0-9_]{6,20}$/.test(value) || value === '') {
              callback()
            } else {
              callback(new Error('请输入6-20位字母、数字、下划线组合代理商账号'))
            }
          },
          trigger: 'blur'
        }],
        FAgentPassword: [{ required: true, message: '请输入登录密码', trigger: 'blur' }, {
          validator: (rule, value, callback) => {
            if (/^[a-zA-Z0-9_]{6,20}$/.test(value) || value === '') {
              callback()
            } else {
              callback(new Error('请输入6-20位字母、数字、下划线组合登录密码'))
            }
          },
          trigger: 'blur'
        }],
        confirmPassword: [{ required: true, message: '请输入确认密码', trigger: 'blur' }, {
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入确认密码'))
            } else if (value !== this.agentInfo.FAgentPassword) {
              callback(new Error('两次输入的密码不一致!'))
            } else if (/^[a-zA-Z0-9_]{6,20}$/.test(value)) {
              callback()
            } else {
              callback(new Error('请输入6-20位字母、数字、下划线组合确认密码'))
            }
          }
        }],
        FMobile: [{
          validator: (rule, value, callback) => {
            if (!(/^\d{11,11}$/.test(value))) {
              callback(new Error('请输入11位手机号码'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FRegisteredCapital: [
          { required: true, message: '请输入注册资金', trigger: 'blur' },
          {
            pattern: /^[0-9]*[1-9][0-9]*$/,
            required: true,
            message: '请输入正整数金额',
            trigger: 'blur'
          }
        ],
        FName: [
          { required: true, message: '请输入正确姓名', trigger: 'blur' },
          { pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }
        ],
        FIdentityCard: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入身份证号'))
            } else {
              // eslint-disable-next-line no-useless-escape
              if (!(/(^[\d|\*]{15}$)|(^[\d|\*]{18}$)|(^[\d|\*]{17}(\d|X|x)$)/.test(value))) {
                callback(new Error('请输入身份证号'))
              } else {
                callback()
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        FEmail: [
          { required: true, message: '请输入正确的电子邮箱', trigger: 'blur' },
          {
            required: true,
            pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
            trigger: 'blur',
            message: '邮箱格式错误，请重新输入'
          }
        ],
        FNotifyAddress: [{ pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }],
        FBankAccount: [
          { required: true, message: '请输入正确的开户名', pattern: /(?!^\w+$)^.{1,80}$/, trigger: 'blur' },
          { pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }
        ],
        FBankCardid: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入正确的开户许可证账号'))
            } else {
              // eslint-disable-next-line no-useless-escape
              if (/^[\d|\*]{5,24}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的开户许可证账号'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        confirmBankCardId: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入确认的开户许可证账号'))
            } else if (value !== this.agentInfo.FBankCardid) {
              callback(new Error('两次输入的开户许可证账号不一致!'))
            // eslint-disable-next-line no-useless-escape
            } else if (/^[\d|\*]{5,24}$/.test(value)) {
              callback()
            } else {
              callback(new Error('请输入确认的开户许可证账号'))
            }
          }
        }]
      },
      pics2: {
        FBdagentPhoto: '',
        FIdentityCardFront: '',
        FIdentityCardBack: '',
        FBusinessLicense: '',
        FTaxRegistration: '',
        // 上面是绝对路径，存储到数据库，下面是url，显示到页面

        FBdagentPhotoUrl: '',
        FIdentityCardFrontUrl: '',
        FIdentityCardBackUrl: '',
        FBusinessLicenseUrl: '',
        FTaxRegistrationUrl: ''
      },
      picLoadingArr2: [
        { FBdagentPhoto: false },
        { FIdentityCardFront: false },
        { FIdentityCardBack: false },
        { FBusinessLicense: false },
        { FTaxRegistration: false }
      ],
      bank_list: [], // 银行列表
      branch_list: [], // 分行列表
      bank_pro_list: [], // 银行网点省列表
      bank_city_list: [], // 银行网点城市列表
      isBankCardIdLuhmChecked: false, // 银行卡开号是否正确
      FAgentAccountError: '', // 代理商登录名错误提醒
      submitAgentLoading: false// 提交代理商入网表单按钮加载中
    }
  },
  mounted () {
    switch (process.env.CUSTOM_ENV) {
      case 'test': {
        this.domain = 'http://t-baseweb.lszzg.com/'
        break
      }
      case 'pre': {
        this.domain = 'http://p-baseweb.lszzg.com/'
        break
      }
      default: {
        this.domain = 'https://baseweb.lszzg.com/'
      }
    }
    this.getProv()
    this.getBank()
    this.getBankPro()
    // 读取本地存储数据
    this.getLocalStorageSurveyInfo()
    // 设置触发对应事件时进行本地存储
    this.setStoreOnEvent()
  },
  watch: {
    '$refs.surveyInfo': function () {
      // 表单变动时重新刷新存储事件监视
      this.setStoreOnEvent()
    }
  },
  methods: {
    // 获取省列表
    getProv () {
      var that = this
      this.$jquery.ajax({
        type: 'get',
        async: false,
        dataType: 'jsonp',
        url: that.domain + 'leposweb/channel/get-all-province.do',
        contentType: 'application/json; charset=utf-8',
        success: function (res) {
          // eslint-disable-next-line no-eval
          that.pro_list = eval(res.list)
        }
      })
    },
    upload (param) {
      var that = this
      // var file = ''
      var picType = param
      var picFile = that.pics[picType + 'Url']
      var reader = new FileReader()
      that.picLoadingArr[picType] = true
      reader.readAsDataURL(picFile)
      reader.onload = function (e) {
        var file = this.result
        file = file.split('base64,')
        var data = {
          // merchantId : merchantId,
          base64pic: file[1],
          picType: picType
        }
        data = qs.stringify(data)
        uploadPic(data).then(data => {
          that.picLoadingArr[picType] = false
          if (parseInt(data.error_code) === 0) {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            var showPicKey = picType + 'Url'
            that.pics[picType] = data.showPath
            that.pics[showPicKey] = data.path
            that.surveyInfo[showPicKey] = data.path
            // 上传后存储在本地
            that.storeToLocal()
          } else {
            that.$message({
              message: data.error_msg,
              type: 'error'
            })
          }
        })
        that.picLoadingArr[picType] = false
      }
    },
    // 设置省
    setProv (id, key) {
      const type = key.replace('Province', '')
      const selected = this.pro_list.filter(function (item) {
        return item.F_province_no === id
      })
      const value = selected[0].F_province_name
      this.surveyInfo[key] = value
      const number = key + 'No'
      this.surveyInfo[number] = id
      if (this.surveyInfo[key]) {
        const city = type + 'City'
        const cityId = type + 'CityNo'
        const area = type + 'Area'
        const areaId = type + 'AreaNo'
        this.surveyInfo[city] = ''
        this.surveyInfo[cityId] = ''
        this.surveyInfo[area] = ''
        this.surveyInfo[areaId] = ''
        this.getCity(key)
      }
    },
    // 设置市
    setCity (id, key) {
      const type = key.replace('City', '')
      const selected = this.city_list[type].filter(function (item) {
        return item.F_city_no === id
      })
      const value = selected[0].F_city_name
      this.surveyInfo[key] = value
      const number = key + 'No'
      this.surveyInfo[number] = id
      if (this.surveyInfo[key]) {
        const area = type + 'Area'
        const areaId = type + 'AreaNo'
        this.surveyInfo[area] = ''
        this.surveyInfo[areaId] = ''
        this.getArea(key)
      }
    },
    // 设置区
    setArea (id, key) {
      const type = key.replace('Area', '')
      const selected = this.area_list[type].filter(function (item) {
        return item.F_area_no === id
      })
      const value = selected[0].F_area_name
      const number = key + 'No'
      this.surveyInfo[key] = value
      this.surveyInfo[number] = id
    },
    // 获取市列表
    getCity (key) {
      var that = this
      var provinceName = that.surveyInfo[key]
      provinceName = qs.stringify({ provinceName: provinceName })
      this.$jquery.ajax({
        type: 'GET',
        async: false,
        dataType: 'jsonp',
        data: provinceName,
        url: that.domain + 'leposweb/home/getcity.do',
        contentType: 'application/json; charset=utf-8',
        success: function (res) {
          const keyword = key.replace('Province', '')
          // eslint-disable-next-line no-eval
          that.city_list[keyword] = eval(res.list)
        }
      })
    },
    // 获取区域
    getArea (key) {
      var that = this
      var cityName = that.surveyInfo[key]
      cityName = qs.stringify({ cityName: cityName })
      this.$jquery.ajax({
        type: 'get',
        async: false,
        dataType: 'jsonp',
        data: cityName,
        url: that.domain + 'leposweb/home/getarea.do',
        contentType: 'application/json; charset=utf-8',
        success: function (json) {
          const keyword = key.replace('City', '')
          // eslint-disable-next-line no-eval
          that.area_list[keyword] = eval(json.list)
        }
      })
    },
    /**
             * 设置触发对应事件时进行本地存储
             */
    setStoreOnEvent () {
      // console.log(this.$refs)
      const eventArr = ['blur', 'change', 'select']
      const self = this
      function getChildrenItem (item) {
        if (item.$el.className && item.$el.className.indexOf('el-select') < 0 && item.$el.className.indexOf('el-input') < 0 && item.$el.className.indexOf('el-checkbox') < 0 && item.$el.className.indexOf('el-autocomplete') < 0 && item.$el.className.indexOf('el-textarea')) {
          item.$children.forEach(element => {
            getChildrenItem(element)
          })
        } else {
          eventArr.forEach(eventStr => {
            item.$on(eventStr, event => {
              self.storeToLocal()
            })
          })
        }
      }
      const refs = this.$refs
      for (const key in refs) {
        // eslint-disable-next-line no-prototype-builtins
        if (refs.hasOwnProperty(key)) {
          if (key === 'surveyInfo') {
            const element = refs[key]
            getChildrenItem(element)
          }
        }
      }
    },
    /**
             * 本地存储方法
             */
    storeToLocal () {
      const addInfo = {
        pics: this.pics,
        surveyInfo: { ...this.surveyInfo }
      }
      localStorage.setItem('AGENT_REGISTER_INFO', JSON.stringify(addInfo))
    },
    /**
             * 读取本地存储数据方法
             */
    async getLocalStorageSurveyInfo () {
      const storageAddInfo = localStorage.getItem('AGENT_REGISTER_INFO')
      if (storageAddInfo && storageAddInfo !== 'undefined') {
        await this.$confirm('是否要读取已保存表单数据？', '提示', {
          confirmButtonText: '读取',
          cancelButtonText: '不读取',
          closeOnClickModal: false
        }).then(() => {
          const storageAddInfoObj = JSON.parse(storageAddInfo)
          for (const key in storageAddInfoObj) {
            // eslint-disable-next-line no-prototype-builtins
            if (storageAddInfoObj.hasOwnProperty(key)) {
              this[key] = storageAddInfoObj[key]
            }
          }
        })
        if (this.surveyInfo.FWorkProvince) {
          this.getCity('FWorkProvince')
        }
        if (this.surveyInfo.FLicenseProvince) {
          this.getCity('FLicenseProvince')
        }
        if (this.surveyInfo.FWorkCity) {
          this.getArea('FWorkCity')
        }
        if (this.surveyInfo.FLicenseCity) {
          this.getArea('FLicenseCity')
        }
        this.resetPicUrl()
      }
    },
    /**
             * 重新获取保存图片临时地址
             */
    resetPicUrl () {
      for (const key in this.pics) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.pics.hasOwnProperty(key)) {
          if (this.surveyInfo[key] && key.indexOf('Url') >= 0) {
            const param = qs.stringify({ path: this.surveyInfo[key] })
            singleTransPic(param).then(response => {
              // console.log('singleTransPic response:', response)
              if (response.error_code === '0') {
                this.pics[key] = response.data.show_path
              }
            })
          }
        }
      }
    },
    // 提交表单
    submitSurvey () {
      let result
      this.$refs.surveyInfo.validate((valid) => {
        result = valid
      })
      if (!result) {
        this.$message({
          message: '代理商意向调查信息有误或不完整，请完善相关信息',
          type: 'warning'
        })
        return
      }
      const checkPic = this.checkPic()
      if (checkPic === false) {
        return false
      }
      // this.surveyInfo.FBusinessBDName = 'kevinluo'
      const data = qs.stringify(this.surveyInfo)
      const that = this
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.submitSurveyLoading = true
        agentSurvey(data).then(data => {
          that.submitSurveyLoading = false
          if (data.result_cde !== '0') {
            that.$message({
              showClose: true,
              message: data.result_msg,
              type: 'error'
            })
          } else {
            this.$message({
              message: data.result_msg,
              type: 'success'
            })
            this.close()
          }
        }).catch(() => {
          that.$message({
            showClose: true,
            message: data.result_msg,
            type: 'error'
          })
        })
      })
    },
    // 校验图片是否为空
    checkPic () {
      for (var key in this.picCheck) {
        if (this.picCheck[key].required && this.surveyInfo[key + 'Url'] === '') {
          this.$message({
            showClose: true,
            message: this.picCheck[key].label + '不能为空',
            type: 'error'
          })
          return false
        }
      }
      return true
    },
    close () {
      this.$emit('update:visible', false)
    },
    // 获取银行列表
    getBank () {
      var that = this
      this.$jquery.ajax({
        type: 'POST',
        asyn: false,
        url: that.domain + 'leposweb/home/getbanknamecode.do',
        contentType: 'application/json; charset=utf-8',
        dataType: 'jsonp',
        success: function (res) {
          // eslint-disable-next-line no-eval
          that.bank_list = eval(res.list)
        }
      })
    },
    // 获取银行省列表
    getBankPro () {
      var that = this
      this.$jquery.ajax({
        type: 'GET',
        async: false,
        dataType: 'jsonp',
        url: that.domain + 'leposweb/home/getbankareacode.do',
        contentType: 'application/json; charset=utf-8',
        success: function (res) {
          // eslint-disable-next-line no-eval
          that.bank_pro_list = eval(res.list)
        }
      })
    },
    // 获取市列表
    getBankCity () {
      var that = this
      var bankAreaCode = this.agentInfo.FBankAreaCode
      this.$jquery.ajax({
        type: 'GET',
        async: false,
        dataType: 'jsonp',
        data: { bankAreaCode: bankAreaCode },
        url: that.domain + 'leposweb/home/getbankcitycode.do?',
        contentType: 'application/json; charset=utf-8',
        success: function (json) {
          console.log(json.list)
          // eslint-disable-next-line no-eval
          that.bank_city_list = eval(json.list)
        }
      })
    },
    // 设置银行名称
    setBankName (value) {
      let obj = {}
      obj = this.bank_list.find((item) => {
        return item.F_bank_name === value
      })
      this.agentInfo.FBankType = value
      this.agentInfo.FBankTypeCode = obj.F_bank_name_code
      if (this.agentInfo.FBankTypeCode && this.agentInfo.FBankCityCode) {
        this.getBranchList()
      }
    },
    // 获取支行列表
    getBranchList () {
      var that = this
      var bankNo = this.agentInfo.FBankTypeCode
      var cityNo = this.agentInfo.FBankCityCode
      // that.seloading = true;
      console.log({ bankNo: bankNo, cityNo: cityNo })
      this.$jquery.ajax({
        type: 'POST',
        url: this.domain + 'leposweb/home/getbankbranch2.do',
        data: { bankNo: bankNo, cityNo: cityNo },
        dataType: 'jsonp',
        success: function (json) {
          console.log(json)
          if (json.result === 1) {
            that.$message({
              showClose: true,
              message: json.errorMsg,
              type: 'warning'
            })
          }
          // eslint-disable-next-line no-eval
          json = eval(json.list)
          that.branch_list = json
          // that.seloading = false
        }
      })
    },
    // 设置省
    setBankPro (value) {
      if (value) {
        let obj = {}
        obj = this.bank_pro_list.find((item) => {
          return item.F_bank_area === value
        })
        this.agentInfo.FBankArea = value
        this.agentInfo.FBankAreaCode = obj.F_bank_area_code
        if (this.agentInfo.FBankAreaCode) {
          this.getBankCity()
        }
      }
      this.agentInfo.FBankCity = ''
      this.agentInfo.FBankCityCode = ''
      this.agentInfo.FBankPoint = ''
      this.agentInfo.FUnionpayCode = ''
      // console.log(this.addForm);
    },
    // 设置市
    setBankCity (value) {
      if (value) {
        let obj = {}
        obj = this.bank_city_list.find((item) => {
          return item.F_bank_city === value
        })
        this.agentInfo.FBankCity = value
        this.agentInfo.FBankCityCode = obj.F_bank_city_code
        if (this.agentInfo.FBankCityCode) {
          this.getBranchList()
        }
      }
      this.agentInfo.FBankPoint = ''
      this.agentInfo.FUnionpayCode = ''
    },
    // 设置银行分支
    setBankBranch (value) {
      if (value) {
        let obj = {}
        obj = this.branch_list.find((item) => {
          return item.F_branch_name === value
        })
        this.agentInfo.FUnionpayCode = obj.F_branch_no
      }
    },
    /**
             * 选择银行城市获取焦点方法
             */
    handleBankCityFocus () {
      if (this.agentInfo.FBankAreaCode && this.bank_city_list.length === 0) {
        this.getBankCity()
      }
    },
    /**
             * 支行输入框获取焦点事件
             */
    handleBankBranchFocus () {
      if (this.agentInfo.FBankTypeCode && this.agentInfo.FBankCityCode && this.branch_list.length === 0) {
        this.getBranchList()
      }
    },
    /**
             * 开户号输入框获取焦点事件
             */
    handleBankCardIdBlur () {
      if (this.agentInfo.FBankCardid) this.isBankCardIdLuhmChecked = !luhmCheck(this.agentInfo.FBankCardid)
    },
    // 代理商入网表单上传图片
    upload2 (param) {
      var that = this
      // var file = ''
      var picType = param
      var picFile = that.pics2[picType + 'Url']
      var reader = new FileReader()
      that.picLoadingArr2[picType] = true
      reader.readAsDataURL(picFile)
      reader.onload = function (e) {
        var file = this.result
        file = file.split('base64,')
        var data = {
          // merchantId : merchantId,
          base64pic: file[1],
          picType: picType
        }
        data = qs.stringify(data)
        uploadPic(data).then(data => {
          that.picLoadingArr2[picType] = false
          if (parseInt(data.error_code) === 0) {
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
            var showPicKey = picType + 'Url'
            that.pics2[picType] = data.showPath
            that.pics2[showPicKey] = data.path
            that.agentInfo[showPicKey] = data.path
            // that.pics[picType] = data.path;
          } else {
            that.$message({
              message: data.error_msg,
              type: 'error'
            })
          }
        })
        that.picLoadingArr2[picType] = false
      }
    },
    /* 检测商户账号可用性 */
    checkUserName () {
      var userName = this.agentInfo.FAgentAccount
      if (userName === '') {
        this.$message({
          message: '请输入代理商账号.'
        })
        return false
      }
      userName = qs.stringify({ userName: userName })
      this.userNameItemError = ''
      checkUsername(userName).then(data => {
        if (parseInt(data.error_code) === 0) {
          this.$message({
            message: data.error_msg,
            type: 'success'
          })
        } else {
          this.FAgentAccountError = data.error_msg
          this.$message({
            message: data.error_msg,
            type: 'warning'
          })
        }
      })
    },
    // 提交入网申请
    submitAgent () {
      let result
      this.$refs.agentInfo.validate((valid) => {
        result = valid
      })
      if (!result) {
        this.$message({
          message: '代理商入网申请信息有误或不完整，请完善相关信息',
          type: 'warning'
        })
        return
      }
      if (this.agentInfo.FTitle === '') {
        this.$message({
          message: '请输入有效的授权码',
          type: 'warning'
        })
        return
      }
      const data = qs.stringify(this.agentInfo)
      const that = this
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.submitAgentLoading = true
        agentRegister(data).then(data => {
          that.submitAgentLoading = false
          if (parseInt(data.result_cde) !== 0) {
            that.$message({
              showClose: true,
              message: data.result_msg,
              type: 'error'
            })
          } else {
            this.$message({
              message: data.result_msg,
              type: 'success'
            })
            this.close()
          }
        }).catch(() => {
          that.$message({
            showClose: true,
            message: data.result_msg,
            type: 'error'
          })
        })
      })
    },
    // 根据授权码获取商户信息
    getInfoByCode () {
      if (this.agentInfo.authCode === '') return
      const data = qs.stringify({ authCode: this.agentInfo.authCode })
      const that = this
      getInfoByAuthCode(data).then(data => {
        const result = data.data
        if (parseInt(data.result_cde) !== 0) {
          that.$message({
            showClose: true,
            message: data.result_msg,
            type: 'error'
          })
        } else {
          this.agentInfo.FTitle = result.FTitle
          this.agentInfo.FAgentProvince = result.FAgentProvince
          this.agentInfo.FAgentCity = result.FAgentCity
          this.agentInfo.FAgentArea = result.FAgentArea
          this.agentInfo.FAddress = result.FAgentArea + result.FAddress
          this.agentInfo.FAgentProvinceNo = result.FAgentProvinceNo
          this.agentInfo.FAgentCityNo = result.FAgentCityNo
          this.agentInfo.FAgentAreaNo = result.FAgentAreaNo
          this.agentInfo.FBdagentPhoto = result.FBdagentPhotoUrl
          this.pics2.FBdagentPhoto = result.FBdagentPhoto
          this.pics2.FBdagentPhotoUrl = result.FBdagentPhotoUrl
          this.agentInfo.FIdentityCardFront = result.FIdentityCardFrontUrl
          this.pics2.FIdentityCardFront = result.FIdentityCardFront
          this.pics2.FIdentityCardFrontUrl = result.FIdentityCardFrontUrl
          this.agentInfo.FIdentityCardBack = result.FIdentityCardBackUrl
          this.pics2.FIdentityCardBack = result.FIdentityCardBack
          this.pics2.FIdentityCardBackUrl = result.FIdentityCardBackUrl
          this.agentInfo.FBusinessLicense = result.FBusinessLicenseUrl
          this.pics2.FBusinessLicense = result.FBusinessLicense
          this.pics2.FBusinessLicenseUrl = result.FBusinessLicenseUrl
          this.agentInfo.FTaxRegistration = result.FTaxRegistrationUrl
          this.pics2.FTaxRegistration = result.FTaxRegistration
          this.pics2.FTaxRegistrationUrl = result.FTaxRegistrationUrl
        }
      }).catch(() => {
        that.$message({
          showClose: true,
          message: data.result_msg,
          type: 'error'
        })
      })
    }
  }
}
</script>

<style scoped>
    .main-view:after{
        content: '';
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }
    .agentRegister{
        width: 160px;
        float: left;
    }
    .rightContent{
        float: left;
        width: calc(100% - 160px);
    }
    .form-input{
        width: 400px;
    }
    .pic_label_text {
        margin-bottom: 15px;
        color: #606266;
        text-align: center;
        align-self: center;
    }
    .pic_label_text label {
        line-height: 20px;
        height: 20px;
        margin-bottom: 10px;
        vertical-align: text-bottom;
    }
    .pic_label_text i {
        font-size: 20px;
        margin-left: 10px;
    }
    h3{
        padding-left: 10px;
        border-left: solid 7px #0099ff;
    }
    .btnItem{
        margin-top: 10px;
        text-align: center;
    }
    .imgPad{
    margin-left: 10px;
    margin-bottom: 10px;
  }
</style>
<style>
    .relat{
        position:relative
    }
    .margBt {
        margin-bottom:10px
    }
</style>
